module.exports = __webpack_public_path__ + "11494889f3f39b8cadc43c2fbc698344.png";